import { render, staticRenderFns } from "./TestSearch.vue?vue&type=template&id=66d0342f&scoped=true&"
import script from "./TestSearch.vue?vue&type=script&lang=js&"
export * from "./TestSearch.vue?vue&type=script&lang=js&"
import style0 from "./TestSearch.vue?vue&type=style&index=0&id=66d0342f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d0342f",
  null
  
)

component.options.__file = "TestSearch.vue"
export default component.exports